import { get, post } from '@/utils/axios';

export default {
  // 获取直播列表
  fetchLiveList(params) {
    // return get('/api/frontend/cloudlive/live/page-lives', params);
    return get('/wxLive/user/getLiveInfoByMobile', params);
  },
  // 获取直播详情
  fetchLiveDetail(params) {
    return get('/api/frontend/cloudlive/live/get-live-info', params);
  },
  // 删除直播
  fetchLiveDelete(params) {
    // return get('/api/frontend/cloudlive/live/delete-live', params);
    return get('/wxLive/live/deleteLive', params);
  },
  // 增加点赞数量
  // addPraise(params) {
  //   return get('/api/frontend/cloudlive/live/set-praise', params);
  // },
  // 删除评论
  deleteComment(params) {
    return get('/api/frontend/cloudlive/live/delete-live-comment', params);
  },
  // 保存直播
  saveLiveRoom(params) {
    // return post('/api/frontend/cloudlive/live/save-live-room', params);
    return post('/wxLive/live/addLive', params);
  },
  // 扫码预约直播
  addCodeLiveRoom(params) {
    return post('/wxLive/live/addLiveByPhone', params);
  },
  // 扫码显示直播列表
  fetchLiveListToCode(params) {
    return get('/wxLive/live/getPersonLiveList', params);
  },
  // 获取扫码直播详情
  fetchLiveCodeDetail(params) {
    return get('/wxLive/live/getLiveInfo', params);
  },
  // 获取扫码直播详情
  fetchLiveCodeDetailForStatus(params) {
    return get('/wxLive/live/getLiveStatusInfo', params);
  },
  // 开启直播
  startLive(params) {
    return post('/wxLive/live/startLive', params);
  },
  // 扫码分享增加看次数
  addViewsCode(params) {
    return get('/wxLive/live/addWatchTimes', params);
  },
  // 扫码预约增加点赞次数
  addPraise(params) {
    return get('/wxLive/public/addPraise', params);
  },
  // 扫码分享获取点赞次数
  fetchLivePraiseCount(params) {
    return get('/wxLive/public/getTotalPraise', params);
  },
  // 增加评论
  addComment(params) {
    return post('/api/frontend/cloudlive/live/save-live-comment', params);
  },
  // 扫码分享增加评论
  addCommentCode(params) {
    return get('/wxLive/public/addComments', params);
  },
  // 获取评论列表
  fetchLiveComments(params) {
    return get('/api/frontend/cloudlive/live/page-live-comments', params);
  },
  // 扫码分享获取评论列表
  fetchLiveCommentsCode(params) {
    return get('/wxLive/public/getComments', params);
  },
  //增加观看次数
  addViews(params) {
    return get('/api/frontend/cloudlive/live/save-view-counts', params);
  },
  // 判断学校是否开通直播权限
  checkSchoolAuth(params) {
    return get('/liveApi/liveService/checkSchoolIsValid', params);
  },
  // 获取地区列表
  getAreaList(params) {
    return get('/wxLive/user/searchArea', params);
  },
  // 获取学校列表
  getSchoolList(params) {
    return get('/wxLive/user/searchSchools', params);
  },
  // 注册
  setRegister(params) {
    return get('/wxLive/user/registerUser', params);
  },
  // 修改用户信息
  updateUserInfo(params) {
    return get('/wxLive/user/updateUserInfo', params);
  }
};
